export default __webpack_public_path__ + "static/media/user-check.67d94d7d.svg";